import { useEffect } from "react";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} | MHM SUPER ADBLUE` : "MHM SUPER ADBLUE";
    const m = document.querySelector('meta[name="description"]');
    if (m && description) m.setAttribute("content", description);
  }, [title, description]);
  return null;
}
